import React, {Component} from 'react'
import {Transition} from 'semantic-ui-react'
import {connect} from 'react-redux'
import {setMenuVisible} from '../actions'

import axios from "axios";
import {loadResourcesProduction} from '../utils/homeUtils'
import http from '../utils/http-common'
import {productionBaseUrl} from '../config/const';

import styles from './ProductionList.module.scss'
import MenuIconDesktop from '../components/MenuIconDesktop';

class ProductionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageVisible: false,
            language: "",
            sectionActive: [true, false, false, false],
            steps: [false, false, false, false, false],
            selectedProduction: {
                block: "",
                background: ""
            },
            styles:[
                {backgroundImage: "aliceblue"},{backgroundImage: "aliceblue"},{backgroundImage: "aliceblue"},{backgroundImage: "aliceblue"}
            ],
            categories:[],
            productions: [],
            grayDesktopBackgrounds: [],
            grayMobileBackgrounds: []
        };

        this.nextPage = "";

        this.toggleClass = this.toggleClass.bind(this);
        this.changeBackground = this.changeBackground.bind(this);
        this.reverseBackground = this.reverseBackground.bind(this);
        this.hideContent = this.hideContent.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
    };

    componentDidMount() {
        loadResourcesProduction();
        this.getLanguage();
    }

    getLanguage() {
        let reqCategories = http.get("/api/v1/productions/categories?language=" + localStorage.getItem("language"));
        let reqProductions = http.get("/api/v1/productions?productionOnly=true&language=" + localStorage.getItem("language"));

        axios.all([reqCategories, reqProductions])
            .then(axios.spread((resCategories, resProductions) => {
                let categories = resCategories.data.filter(cat => cat.key < 10);
                let productions = resProductions.data;
                const grayDesktopBackgrounds = this.getGrayBackgrounds(categories, productions, "gray_desktop");
                const grayMobileBackgrounds = this.getGrayBackgrounds(categories, productions, "gray_mobile");

                const styles = this.getInitStyles(categories, grayDesktopBackgrounds, grayMobileBackgrounds);
                categories = this.setProductionByYearInCategory(categories, productions);

                this.setState({categories: categories, productions: productions,
                    grayDesktopBackgrounds: grayDesktopBackgrounds, grayMobileBackgrounds: grayMobileBackgrounds,
                    styles: styles
                });
            }))
            .catch(error => {console.log(error)});
    }

    getGrayBackgrounds(categories, productions, imageType){
        let grayBackgrounds = [];
        for (let i = 0; i < categories.length; i++) {
            let catProductions = productions.filter(prod => prod.category.key === categories[i].key)
            catProductions = catProductions.length >　0 ? catProductions.sort((a,b)=>{return b.order-a.order}) : catProductions;
            let grayPath = "";
            for (let j = 0; j < catProductions.length; j++) {
                let grayImages = catProductions[j].images.filter(img=>img.apply && img.type===imageType);
                if (grayImages.length > 0) {
                    grayPath = grayImages[0].path;
                    break;
                }
            }
            grayBackgrounds.push(grayPath);
        }
        return grayBackgrounds;
    }

    getInitStyles(categories, grayDesktopBackgrounds, grayMobileBackgrounds){
        let styles = [];
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw >= 768) {
            for (let i = 0; i < categories.length; i++) {
                styles.push({
                    backgroundImage: `url("${productionBaseUrl}${grayDesktopBackgrounds[i]}")`,
                    filter: "grayscale(100%)"
                });
            }
        }
        else {
            for (let i = 0; i < categories.length; i++) {
                styles.push({
                    backgroundImage: `url("${productionBaseUrl}${grayMobileBackgrounds[i]}")`,
                    filter: "grayscale(100%)"
                });
            }
        }
        return styles;
    }

    setProductionByYearInCategory(categories, productions){
        for (let i = 0; i < categories.length; i++) {
            let category = categories[i];
            category["productions"] = new Map();
            let productionsInCategory = productions.filter(production=>production.category.key === category.key);
            for (let j = 0; j < productionsInCategory.length; j++) {
                let production = productionsInCategory[j];
                if (!category.productions.has(production.year)){
                    category.productions.set(production.year, []);
                }
                let yearProductions = category.productions.get(production.year);
                yearProductions.push(production);
                yearProductions.sort(function(a, b) {return a.order - b.order});
                category.productions.set(production.year, yearProductions);
            }
        }
        return categories;
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.categories !== this.state.categories) {
            setTimeout(() => {
                this.setState({
                    isPageVisible: true,
                });
            }, 300);
        }

        if (prevProps.language !== this.props.language) {
            this.getLanguage();
            this.setState({language: this.props.language});
        }
    }

    hideContent() {
        this.setState({
            isPageVisible: false,
        });
    }

    toggleClass(index, e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.sectionActive[index] === true) {
            this.state.sectionActive[index] = false;
            this.setState({sectionActive: this.state.sectionActive});
            return;
        }

        const newSectionActive = this.state.sectionActive.map((currElement, i) => {
            if (index === i) {
                return true;
            } else {
                return false;
            }
        });

        this.setState({sectionActive: newSectionActive});
    }

    changeBackground(index, backgroundUrl) {
        let styles = [...this.state.styles];
        styles[index] = {
            backgroundImage: `url("${backgroundUrl}")`,
            filter: "grayscale(20%)"
        }
        this.setState({styles: styles});
    }

    reverseBackground(index, backgroundUrl) {
        let styles = [...this.state.styles];
        styles[index] = {
            backgroundImage: `url("${backgroundUrl}")`,
            filter: "grayscale(100%)"
        }
        this.setState({styles: styles});
    }

    setStepVisible(index, visible) {
        const steps = [...this.state.steps];
        steps[index] = visible;
        this.setState({steps: steps});
    }

    stripHtmlTag(title) {
        return title.replace(/(<([^>]+)>)/gi, "");
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        const sliderSetting = {
            arrows: false,
            dots: true
        }

        return (
            <>
                <div className={`${styles.production_list} ${styles.desktop} ${this.getLanguageClass()}`}>
                    <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}
                                onHide={() => {
                                    this.props.history.push(this.nextPage)
                                }}>
                        <MenuIconDesktop />
                    </Transition>
                    <Transition visible={this.state.isPageVisible} animation='fade' duration={2000}>
                        <div className={styles.title}>
                            <div className={styles.title_word}>Production</div>
                            <div className={styles.subtitle_block}>
                                <div className={styles.subtitle_word}>OUTLAND Film Production</div>
                            </div>
                        </div>
                    </Transition>

                    <Transition visible={this.state.isPageVisible} animation='fade' duration={1000}
                                onShow={() => {
                                    this.setStepVisible(0, true)
                                }}>
                        <div className={styles.content_container}>
                            <div className={styles.content}>
                                <div className={styles.content_overlay}></div>

                                <article className={styles.accordion}>

                                    {this.state.categories.map((category, indexC) => {
                                        return (
                                          <Transition visible={this.state.steps[0]} animation='fade' duration={1000} key={indexC}
                                                      onShow={() => {
                                                          this.setStepVisible(indexC+1, true)
                                                      }}>
                                              <section id={`acc${indexC+1}`} className={this.state.sectionActive[indexC] === true ? styles.active : null} onClick={(e) => this.toggleClass(indexC, e)}>
                                                  <div className={`${styles.acc1} ${styles.background_overlay}`} style={this.state.styles[indexC]}></div>
                                                  <div className={`${styles.acc1} ${styles.background_overlay} ${styles.background_overlay_gray}`}></div>
                                                  <h2><a >{category.name}</a></h2>
                                                  <div className={`${styles.list_container} ${styles["list_container"+indexC]}`}>
                                                      {[...category.productions.keys()].length > 0 ? [...category.productions.keys()].sort((a,b)=>b-a).map((key) => {
                                                          return (
                                                            <div className={styles.year_block} key={key}>
                                                                <div className={styles.year_block_title}>
                                                                    <div className={styles.year}>{key}</div>
                                                                    <div className={styles.year_block_dotted}>
                                                                        <div className={styles.year_block_dotted_inner}></div>
                                                                    </div>
                                                                </div>
                                                                <ul>
                                                                    { category.productions.get(key).map((production, indexP) => {
                                                                        return (
                                                                          <li key={indexP}
                                                                              onClick={()=>{ this.nextPage="production/"+production.id ; this.hideContent()}}
                                                                              onMouseEnter={() => {
                                                                                  let images = production.images.filter(img=>img.apply).filter(img=>img.type==="desktop");
                                                                                  let path = images.length > 0 ? images[0].path : "";
                                                                                  this.changeBackground(indexC, productionBaseUrl + path)
                                                                              }}
                                                                              onMouseLeave={() => {
                                                                                  this.reverseBackground(indexC, productionBaseUrl + this.state.grayDesktopBackgrounds[indexC]);
                                                                              }}
                                                                          >
                                                                              {this.stripHtmlTag(production.name)}
                                                                          </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </div>
                                                          )
                                                      }) : null}
                                                  </div>
                                              </section>
                                          </Transition>
                                        )
                                    })}

                                </article>
                            </div>
                        </div>
                    </Transition>
                </div>

                <div className={`{styles.production_list} ${styles.mobile} ${this.getLanguageClass()}`}>
                    {/*<div className="display_none">{this.state.language}</div>*/}
                    <div className={styles.menu_wrapper}>
                        <div className={styles.menu} onClick={() => {
                            this.props.setMenuVisible(true)
                        }}>
                        <span className={styles.menu_icon}><div className={styles.menu_icon_line}></div></span>
                            <span>OUTLAND File Production</span>
                        </div>
                    </div>

                    <div className={styles.content_wrapper}>
                        <div className={styles.content_overlay}></div>
                        <div className={styles.content}>
                            <article className={styles.accordion}>

                                {this.state.categories.map((category, indexC) => {
                                    return (
                                      <div key={indexC} className={`${styles.accordion_container} ${this.state.sectionActive[indexC] === true ? styles.active : null}`}>
                                          <div className={`${styles.acc1} ${styles.background_overlay}`} style={this.state.styles[indexC]}></div>
                                          <section id={`acc${indexC+1}`}  className={this.state.sectionActive[indexC] === true ? styles.active : null} style={
                                              this.state.sectionActive[indexC] === true ? { height: document.documentElement.clientHeight - 150 - 80 } : null}>

                                              <h2><a onClick={(e) => this.toggleClass(indexC, e)}>{category.name}</a></h2>
                                              <div className={styles.list_container}>
                                                  {[...category.productions.keys()].length > 0 ? [...category.productions.keys()].sort((a,b)=>b-a).map((key) => {
                                                      return (
                                                        <div className={styles.year_block} key={key}>
                                                            <div className={styles.year_block_title}>
                                                                <div className={styles.year}>{key}</div>
                                                                <div className={styles.year_block_dotted}>
                                                                    <div className={styles.year_block_dotted_inner}></div>
                                                                </div>
                                                            </div>
                                                            <ul>
                                                                { category.productions.get(key).map((production, indexP) => {
                                                                    return (
                                                                      <li key={indexP}
                                                                          onClick={()=>{ this.nextPage="production/"+production.id ; this.hideContent()}}
                                                                        >
                                                                          {this.stripHtmlTag(production.name)}
                                                                      </li>
                                                                    )
                                                                })}
                                                            </ul>
                                                        </div>
                                                      )
                                                  }) : null}
                                              </div>
                                          </section>
                                      </div>
                                    )
                                })}

                            </article>
                        </div>
                    </div>
                    {/*<div className={styles.back_wrapper}></div>*/}
                </div>
            </>

        );
    }

};

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible,
        language: state.language
    };
};

export default connect(mapStateToProps, {setMenuVisible})(ProductionList);
